import { Component, HostBinding, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-colored-dropdown-menu-button',
  templateUrl: './colored-dropdown-menu-button.component.html',
  styleUrls: ['./colored-dropdown-menu-button.component.scss'],
  standalone: false,
})
export class ColoredDropdownMenuButtonComponent {
  @Input()
  radius: 'small' | 'large';

  @Input()
  buttonIcon: string;

  @HostBinding('class.read-only')
  @Input()
  isReadOnly = false;

  @Input()
  buttonBackgroundClass: string;

  @Input()
  buttonBorderClass: string;

  @Input()
  textClasses: string;

  @Input()
  tooltip: string | TemplateRef<any>;

  @Input()
  verticalSize: 'small' | 'medium';

  @Input()
  horizontalSize: 'small' | 'medium' = 'medium';

  @Input()
  tooltipPlacement = 'top';

  @Input()
  keepTooltipOnOver = false;

  @Input()
  arrowEnabled: boolean;

  @Input()
  arrowBlackColor: boolean;

  @Input()
  tooltipClasses = '';

  @Input()
  iconClasses = 'mr-1.5 h-3';

  @HostBinding('class.active')
  @Input()
  isOpen: boolean;
}
